import { render } from "./JFdefeated.vue?vue&type=template&id=78a6ca8f&scoped=true"
import script from "./JFdefeated.vue?vue&type=script&lang=js"
export * from "./JFdefeated.vue?vue&type=script&lang=js"

import "./JFdefeated.vue?vue&type=style&index=0&id=78a6ca8f&lang=scss&scoped=true"
import "./JFdefeated.vue?vue&type=style&index=1&id=78a6ca8f&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a6ca8f"]])

export default __exports__